<template>
    <b-button
        id="coi-action-bar-reprint-label"
        @click="submit()"
        block
    ><!-- button -->
        Erneut drucken
    </b-button>
</template>
<script>
    export default {
        props: ['customerOrderId', 'customerOrderItemDeliveryAddition'],
        data() {
            return {

            }
        },
        methods: {
            submit() {
                console.log("called COIActionBarReprint::submit()");
			    const shippingId = customerOrderItemDeliveryAddition.shippingId;
                switch(this.customerOrderItemDeliveryAddition.shippingService)
                {
                    case 5:
                        if(shippingId == 'Packstation') {
                            this.openLink(
                                axios.get(`customerorder/list?download=rfidlabel&customerorderid=${this.customerOrder.id}`)
                            );
                        }
                        else
                        {
                            alert("unbekannter fall"); //TODO php impl. ignores this case.
                        }
                        break;
                    // TODO ... other cases
                }
            },

            downloadLink( axiosRequest ) { //TODO actually reprint/download label

                axiosRequest.then( response => {
                    const url  = this.window.URL.createObjectURL(new Blob([atob(response.data.label)]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `label_${response.data.shipmentId}.pdf`);
                    document.body.appendChild(link);
                    link.click();
                });

            }

        }

    }
</script>

<!-- 

	$serviceId = $rs->getString("shippingService");
			$shippingId = $rs->getString("shippingId");
            switch($serviceId){
            case 7:
              echo link_to('Erneut drucken', 'customerorder/list?download=rfidlabel&customerorderid='.$customer_order->getId());
            break;
			case 5:
				if($shippingId == "Packstation")
				{
					echo link_to('Erneut drucken', 'customerorder/list?download=label&customerorderid='.$customer_order->getId());
					break;
				}
			case 2:
            	echo '<a href="javascript:void(0)" onclick="labelDHL('.$customer_order->getId().');">Erneut drucken</a>'; //link_to('Erneut drucken', 'customerorder/list?download=dhl&customerorderid='.$customer_order->getId());
            break;
            case 8:
            case 9:
			case 10:
              echo '<a href="javascript:void(0)" onclick="labelDPD('.$customer_order->getId().');">Erneut drucken</a>'; //link_to('Erneut drucken', 'customerorder/list?download=dhl&customerorderid='.$customer_order->getId());
			break;
			case 6:
				if($shippingId != null)
				{
					echo '<a href="javascript:void(0)" onclick="$.fileDownload(\'http://synchrotron.mplusl.de:55556/index.php/dhlexp/downloadLabel?file='.$shippingId.'.zpl\')">Erneut drucken</a>';
				}
				else
				{
					echo link_to('Erneut drucken', 'customerorder/list?download=label&customerorderid='.$customer_order->getId());
					echo '</br><a href="synch://'.$userToId[sfContext::getInstance()->getUser()->getAttribute("username")].'@print/dhltemp/'.$customer_order->getId().'">V2 Erneut drucken</a>';
				}
			break;
			case 4:
				if($shippingId != null)
				{
					echo '<a href="javascript:void(0)" onclick="$.fileDownload(\'http://synchrotron.mplusl.de:55556/index.php/upsexp/downloadLabel?file='.$shippingId.'_label.epl\')">Erneut drucken</a>';
				}
				else
				{
					echo link_to('Erneut drucken', 'customerorder/list?download=label&customerorderid='.$customer_order->getId());
				}
			break;
            default:
			  echo link_to('Erneut drucken', 'customerorder/list?download=label&customerorderid='.$customer_order->getId());
            break;     
            }
            
         }
         if($serviceId == 0){
           echo link_to('Erneut drucken', 'customerorder/list?download=label&customerorderid='.$customer_order->getId());
         }
-->